import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=fa952f0c&"
import script from "./ButtonBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports